import React from "react";
import type { Volume } from "../../data/volumes";
type VolumeCardProps = {
  volume: Volume;
};
export function VolumeCard({
  volume
}: VolumeCardProps) {
  return <article className="grid overflow-hidden rounded-xl border border-navy/10 bg-white shadow-[0_10px_24px_-18px_rgba(28,47,79,0.45)] md:grid-cols-[150px_1fr]" data-id="element-270" data-mp="2nfhrsif7qm7h">
      <div className="flex items-center justify-between gap-4 p-5 text-white md:flex-col md:items-start md:justify-start" style={{
      backgroundColor: volume.color
    }} data-id="element-271" data-mp="2wd1pjhdva0dc">
        <div data-id="element-272" data-mp="24mnlsdzki4fe">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-273" data-mp="24o8f60a5bhbo">Volume</p>
          <p className="font-display text-4xl font-black leading-none" data-id="element-274" data-mp="28nz2tv4dlhbz">{volume.number}</p>
        </div>
        {volume.meta && <ul className="space-y-0.5 text-right text-xs font-bold md:mt-4 md:text-left" data-id="element-275" data-mp="2dhlhfsu3nvaf">
            {volume.meta.map(m => <li key={m} data-id="element-276" data-mp="1kz6dihi9e7qc">{m}</li>)}
          </ul>}
      </div>

      <div className="flex flex-col p-5" style={{
      backgroundColor: `${volume.color}12`
    }} data-id="element-277" data-mp="1kxd5oyvwthgr">
        <h4 className="font-display text-base font-black uppercase leading-tight md:text-lg" style={{
        color: volume.color
      }} data-id="element-278" data-mp="1uvsxpjejg2br">
          Volume {volume.number} — {volume.title}
        </h4>
        {volume.description && <p className="mt-2 text-sm text-navy/80" data-id="element-279" data-mp="1l4okao4igpj1">{volume.description}</p>}

        {volume.workouts && <ul className="mt-3 grid gap-2 sm:grid-cols-3" data-id="element-280" data-mp="1g5bupvm994cr">
            {volume.workouts.map(w => <li key={w.label} className="rounded-lg bg-white p-3" data-id="element-281" data-mp="1b68s0htqza7y">
                <p className="font-display text-xs font-black uppercase text-green" data-id="element-282" data-mp="1756npmkz47z4">{w.label}</p>
                <p className="mt-0.5 text-xs font-semibold text-navy" data-id="element-283" data-mp="128gbxbg7byji">{w.focus}</p>
              </li>)}
          </ul>}

        {volume.groups.map(group => <div key={group.title} className="mt-4" data-id="element-284" data-mp="2wkmwh0uzjroh">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.15em] text-navy/60" data-id="element-285" data-mp="2wjbu95h6urzh">{group.title}</p>
            <ul className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-286" data-mp="pxfjdsqvcwec">
              {group.items.map(item => <li key={item} className="rounded-full border px-2.5 py-0.5 text-xs font-medium text-navy" style={{
            borderColor: `${volume.color}33`,
            backgroundColor: "#FFFFFF"
          }} data-id="element-287" data-mp="unvwfbqs2g06">
                  {item}
                </li>)}
            </ul>
          </div>)}

        <p className="mt-4 border-t pt-3 font-display text-sm font-black uppercase" style={{
        color: volume.color,
        borderColor: `${volume.color}26`
      }} data-id="element-288" data-mp="kvzzw54caxy2">{volume.closing.join(" ")}</p>
      </div>
    </article>;
}